import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Layout from "./components/Layout";
import { BuyPlanDialog } from "./components/BuyPlanDialog";
import { Spinner } from "./components/AiHtml";
import Login from "./pages/Login";
import Onboarding from "./pages/Onboarding";
import Paused from "./pages/Paused";
import Dashboard from "./pages/Dashboard";
import Employees from "./pages/Employees";
import EmployeeChat from "./pages/EmployeeChat";
import ResearchStudio from "./pages/ResearchStudio";
import Auditor from "./pages/Auditor";
import AdsManager from "./pages/AdsManager";
import ContentStudio from "./pages/ContentStudio";
import EmailStudio from "./pages/EmailStudio";
import WebsiteBuilder from "./pages/WebsiteBuilder";
import ImageStudio from "./pages/ImageStudio";
import VideoStudio from "./pages/VideoStudio";
import Scheduler from "./pages/Scheduler";
import Pricing from "./pages/Pricing";
import Admin from "./pages/Admin";
import SocialManager from "./pages/SocialManager";
import AuthCallback from "./pages/AuthCallback";

const Guard = ({ children, admin }) => {
  const { user } = useAuth();
  if (user === null) return <Spinner label="Loading..." />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.status === "disabled") return <Paused />;
  if (admin && !user.isAdmin) return <Navigate to="/" replace />;
  if (!user.onboarded && !admin) return <Navigate to="/onboarding" replace />;
  return children;
};

function AppRoutes() {
  const { user } = useAuth();
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/onboarding" element={user === null ? <Spinner /> : !user ? <Navigate to="/login" /> : user.status === "disabled" ? <Paused /> : <Onboarding />} />
      <Route element={<Guard><Layout /></Guard>}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/employees" element={<Employees />} />
        <Route path="/employees/:id" element={<EmployeeChat />} />
        <Route path="/research" element={<ResearchStudio />} />
        <Route path="/auditor" element={<Auditor />} />
        <Route path="/ads" element={<AdsManager />} />
        <Route path="/content" element={<ContentStudio />} />
        <Route path="/email" element={<EmailStudio />} />
        <Route path="/website" element={<WebsiteBuilder />} />
        <Route path="/image" element={<ImageStudio />} />
        <Route path="/video" element={<VideoStudio />} />
        <Route path="/scheduler" element={<Scheduler />} />
        <Route path="/social" element={<SocialManager />} />
        <Route path="/pricing" element={<Pricing />} />
      </Route>
      <Route element={<Guard admin><Layout /></Guard>}>
        <Route path="/admin" element={<Admin />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <BuyPlanDialog />
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" richColors />
    </AuthProvider>
  );
}
